import "./MindfulLetoMinds.css";

function MindfulLetoMinds() {
  return (
    <div className="page-container">
      <h1>Mindful Leto Minds</h1>
      <p>A holistic program connecting your mind and spirit.</p>
    </div>
  );
}

export default MindfulLetoMinds;
